import { FC, useRef } from "react";
import FormLayout from "../FormLayout";
import { Box, Card } from "@mui/material";
import furnitureController, { IChangeModuleImageDto } from "../../../Api/furnitureController";
import { useToast } from "../../../hooks/useToast";
import { useModal } from "../../../hooks/useModal";

interface EditModuleImageFormProps {
    furnitureId: string;
    moduleId: string;
    onSetModules: (modules: any[]) => void;
}

const EditModuleImageForm: FC<EditModuleImageFormProps> = ({
    furnitureId,
    moduleId,
    onSetModules,
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const toast = useRef(useToast()).current;
    const modal = useModal()

    const handleDrop = async (e: any) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        const data: IChangeModuleImageDto = {
            furnitureId,
            moduleId,
            image: files[0],
        }

        const res = await furnitureController.changeModuleImage(data);
        if (!res.ok) return toast.error(res.message);
        onSetModules?.(res.editedFurniture?.modules || []);
        modal.close();
    };


    const handleFileSelect = async (e: any) => {
        const files = Array.from(e.target.files) as File[];
        const data: IChangeModuleImageDto = {
            furnitureId,
            moduleId,
            image: files[0],
        }

        const res = await furnitureController.changeModuleImage(data);
        if (!res.ok) return toast.error(res.message);
        onSetModules?.(res.editedFurniture?.modules || []);
        modal.close();
    };


    const handleDragOver = (e: any) => {
        e.preventDefault();
    };
    return (
        <FormLayout title="Edytuj zdjęcie modułu">
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, width: '100%' }}>
                <Card
                    sx={{
                        backgroundColor: '#eac5be',
                        border: '3px solid #c85742',
                        width: '100%',
                        maxWidth: '1400px',
                        p: 2,
                        height: '200px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onClick={() => fileInputRef.current?.click()}
                >
                    Przeciągnij zdjęcie tutaj lub kliknij, aby dodać
                </Card>
                <input
                    type="file"
                    multiple
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileSelect}
                />
            </Box>
        </FormLayout>
    )
}

export default EditModuleImageForm;